var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNpm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 100,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 100",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0v85.4980695h71.1660232v14.3320463h56.8339768v-14.3320463h128v-85.4980695z",
    fill: "#cb3837"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42.5019305 14.3320463h-28.1698842v14.3320464 42.5019305h28.1698842v-42.5019305h14.3320463v42.5019305h14.3320464v-42.5019305-14.3320464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.4980695 14.3320463v53.8687259 2.965251 14.3320463h28.6640925v-14.3320463h28.169884v-56.8339769zm42.5019305 42.5019305h-13.837838v-28.1698841h13.837838z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.833977 14.3320463h-28.169884v14.3320464 42.5019305h28.169884v-42.5019305h14.332046v42.5019305h14.332046v-42.5019305h14.332047v42.5019305h14.332046v-42.5019305-13.3436294-.988417z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpm);
export default __webpack_public_path__ + "static/media/npm.d094179a06cfd0192b17d4a38f2f0129.svg";
export { ForwardRef as ReactComponent };